<div class="matrix_pageOptionAttributes" v-if="shouldRenderConfig && showCustomFormat"> 
    <div class="matrix_inpuCustomFormatCotainer">
        <div class="matrix_inpuCustomFormatLabel">{{ $t('Custom format:') }}</div>
        <div class="matrix_inpuCustomFormatItems">
            <div class="matrix_inpuCustomFormatItem">
                <!-- <div class="matrix_inpuCustomFormatItemLabel">{{ $t('Width:') }}</div> -->
                <input type="text" v-model="width" :placeholder="$t('Width:')" v-on:keydown.enter="onEnter"/>
            </div>
            <div class="matrix_inpuCustomFormatItem">
                <!-- <div class="matrix_inpuCustomFormatItemLabel">{{ $t('Height:') }}</div> -->
                <input type="text" v-model="height" :placeholder="$t('Height:')" v-on:keydown.enter="onEnter"/>
            </div>
        </div>
        <button type="button" class="btn btn-primary" v-on:click="onClickInputCustomFormat()">
            {{ $t('Create format') }}
        </button>
    </div>
</div>

